import { handleError } from '@pn/core/errors/handleError';
import { companiesActions, useCompaniesStorage } from '@pn/core/storage';
import { apiCompanyProvider } from '@pn/services/api/company/apiCompanyProvider';
import { isEmpty } from 'lodash-es';
import React from 'react';

async function getCompanies() {
  try {
    companiesActions().request();

    const companies = await apiCompanyProvider.getCompanies();

    companiesActions().receive(companies);
  } catch (error) {
    handleError({
      error,
      onError: companiesActions().error,
      notify: 'Failed to get companies',
    });
  }
}

export function useAutoLoadCompanies() {
  const { companies } = useCompaniesStorage();
  const requestedRef = React.useRef(false);

  React.useEffect(() => {
    if (requestedRef.current || !isEmpty(companies)) return;
    requestedRef.current = true;
    (async () => {
      await getCompanies();
      requestedRef.current = false;
    })();
  }, [companies]);
}
